import { render } from "./RoundRow.vue?vue&type=template&id=7f961444&scoped=true&ts=true"
import script from "./RoundRow.vue?vue&type=script&lang=ts"
export * from "./RoundRow.vue?vue&type=script&lang=ts"

import "./RoundRow.vue?vue&type=style&index=0&id=7f961444&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f961444"]])

export default __exports__